<template>
    <app-data-table
        :fields="fields"
        :items="data"
        @sort="onSort"
        :current-page="tableData.current_page"
        :last-page="tableData.last_page"
        :from="tableData.from"
        :to="tableData.to"
        :total="tableData.total"
        :per-page="tableData.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="businessLines" slot-scope="{ item }">
            <div v-for="bl in item.business_lines" :key="bl.id" :title="bl.name">{{ bl.code }}</div>
        </template>
        <template slot="actions" slot-scope="{ item }">
            <div v-if="!item.deleted_at">
                <b-button
                    size="sm"
                    title="Administrar"
                    variant="primary"
                    @click="manageClient(item)"
                >
                    <i class="fa fa-users"></i>
                </b-button>
                <b-button
                    variant="primary"
                    title="Actualizar"
                    size="sm"
                    @click="updateClient(item)"
                >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </b-button>
                <b-button variant="danger" title="Deshabilitar" size="sm" @click="remove(item)">
                    <i class="fa fa-ban" aria-hidden="true"></i>
                </b-button>
            </div>
            <div v-else>
                <b-button
                    size="sm"
                    title="Habilitar"
                    variant="primary"
                    @click="activateClient(item)"
                >
                    <i class="fa fa-check"></i> Activar
                </b-button>
            </div>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields,
        }
    },
    props: {
        tableData: {
            type: [Array, Object],
        },
        onChangePage: {
            type: Function,
        },
    },
    computed: {
        data() {
            if (!this.tableData || !this.tableData.data) return []

            return this.tableData.data.map(item => {
                const classes = item.deleted_at ? 'disabled' : ''
                const _rowDetails = false
                return { ...item, _rowDetails, classes }
            })
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        updateClient(client) {
            this.$emit('edit', client)
        },
        remove(client) {
            this.$emit('remove', client)
        },
        activateClient(client) {
            this.$emit('activate-client', client)
        },
        manageClient(client) {
            this.$store.commit('client', client)
            this.$router.push({
                name: 'clientContactsPage',
                params: { prospect: true, clientId: client.id },
            })
        },
    },
}

const fields = [
    {
        key: 'name',
        label: 'Nombre',
        filter: true,
    },
    {
        key: 'city.name',
        label: 'Ubicación',
        filter: true,
    },
    {
        key: 'client_type.name',
        label: 'Tipo cliente',
        filter: true,
    },
    {
        key: 'identification_type.name',
        label: 'Tipo documento',
        filter: true,
    },
    {
        key: 'document',
        label: 'Documento',
        filter: true,
    },
    {
        key: 'address',
        label: 'Dirección',
        filter: true,
    },
    {
        key: 'phone',
        label: 'Teléfono',
        filter: true,
    },
    {
        key: 'email',
        label: 'E-mail',
        filter: true,
    },
    {
        key: 'code',
        label: 'Código',
        filter: false,
    },
    {
        key: 'businessLines',
        label: 'Lineas',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
<style>
.disabled {
    text-decoration: line-through;
    color: gray;
}
</style>